import { useCallback } from "react";
import { Dialog } from "../../../components/Dialog/Dialog.tsx";
import { useUser } from "../../hooks/useUser.ts";
import type { User } from "../../types.ts";
import { AccountProfileSettings } from "./AccountProfileSettings.tsx";
import { NavigationPanel } from "./NavigationPanel.tsx";
import { PlanAndBillingSettings } from "./PlanAndBillingSettings.tsx";
import { profileSettingsDialogStore } from "./stores/profileSettingsDialogStore.ts";
import { WorkspaceGeneralSettings } from "./WorkspaceGeneralSettings.tsx";
import { WorkspaceMembersSettings } from "./WorkspaceMemberSettings.tsx";

export const ProfileSettings = () => {
  const { user } = useUser();
  const { isDialogOpen } = profileSettingsDialogStore.useState();

  const onOpenChange = useCallback((open: boolean) => {
    if (open) {
      profileSettingsDialogStore.openDialog();
    } else {
      profileSettingsDialogStore.closeDialog();
    }
  }, []);

  return (
    <Dialog
      title="Settings"
      isOpen={isDialogOpen}
      onOpenChange={onOpenChange}
      content={
        user && (
          <ProfileSettingsContent
            user={user}
            onUpdate={() => onOpenChange(false)}
          />
        )
      }
    />
  );
};

const ProfileSettingsContent = ({
  user,
  onUpdate,
}: {
  user: User;
  onUpdate: () => void;
}) => {
  const { profileSettingsTab } = profileSettingsDialogStore.useState();

  return (
    <div className="h-[680px] w-[960px] flex-row border-t divide-x-025 divide-solid divide-primary-rest">
      <NavigationPanel />
      {profileSettingsTab === "profile" ? (
        <AccountProfileSettings user={user} onUpdate={onUpdate} />
      ) : profileSettingsTab === "general" ? (
        <WorkspaceGeneralSettings onUpdate={onUpdate} />
      ) : profileSettingsTab === "members" ? (
        <WorkspaceMembersSettings />
      ) : (
        <PlanAndBillingSettings />
      )}
    </div>
  );
};
